import InfoText from '../../atoms/InfoText';
import { Image, Table } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useGetDisputeSummaryQuery,
  useGetRequestSummaryQuery,
} from '@/store/services/disputeService';
import LocalDate from '@/components/atoms/LocaleDate';
import SectionWrapper from '@/components/Dispute/SectionWrapper';
import { ClipboardText } from 'iconsax-react';
import Helpers from '@/lib/helpers';
import { Document } from '@/types/Cart';

export default function Summary() {
  const { t } = useTranslation();

  const params = useParams();

  const { data: disputeSummary } = useGetDisputeSummaryQuery(
    { disputeId: params?.disputeId },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const { data: requestSummary } = useGetRequestSummaryQuery(
    { disputeId: params?.disputeId },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const orderDataSource = [
    {
      name: t('components.disputeFeature.orderDate'),
      value: (
        <LocalDate
          date={requestSummary?.payload?.orderDate || new Date()}
          formatStr="dd MMM yyyy | hh:mm a"
          className="!font-semibold !text-light-text-primary dark:!text-dark-text-primary"
        />
      ),
    },
    {
      name: t('components.disputeFeature.orderId'),
      value: requestSummary?.payload?.serial || '-',
    },
    {
      name: t('components.disputeFeature.orderStatus'),
      value: requestSummary?.payload?.orderStatus || '-',
    },
    {
      name: t('components.disputeFeature.orderType'),
      value: requestSummary?.payload?.orderType || '-',
    },
  ];

  const columns = [
    { title: '', dataIndex: 'name', key: 'name' },
    {
      title: '',
      dataIndex: 'value',
      key: 'value',
      className: 'text-end font-semibold',
    },
  ];

  const dataSource = [
    {
      name: t('components.disputeFeature.reason'),
      value: disputeSummary?.payload?.reason,
    },

    {
      name: t('components.disputeFeature.description'),
      value: (
        <InfoText text={disputeSummary?.payload?.description} maxLength={50} />
      ),
    },
    {
      name: t('components.disputeFeature.disputeCreatedAt'),
      value: (
        <LocalDate
          date={disputeSummary?.payload?.createdAt || new Date()}
          formatStr="dd MMM yyyy | hh:mm a"
          className="!font-semibold !text-light-text-primary dark:!text-dark-text-primary"
        />
      ),
    },
    {
      name: t('attachments'),
      value: !!disputeSummary?.payload?.attachments?.length ? (
        <div className="flex items-center justify-end gap-x-2">
          {disputeSummary?.payload?.attachments?.map((a: Document) =>
            a?.extension === 'pdf' ? (
              <Link to={a.blobFileUrl} className="flex flex-col items-center">
                <ClipboardText width={50} />
                <span className="!text-xs">
                  {Helpers.truncateText(a.blobName || a.name, 5)}
                </span>
              </Link>
            ) : (
              <Image src={a.blobFileUrl} width={50} height={50} />
            )
          )}
        </div>
      ) : (
        '-'
      ),
    },
  ];

  return (
    <div>
      <SectionWrapper title={t('components.disputeFeature.disputeSummary')}>
        <div className="space-y-4">
          <Table
            columns={columns}
            className="customTable"
            dataSource={dataSource}
            pagination={false}
            showHeader={false}
            size="middle"
          />

          {/* --------------------------------- Seller actions */}
          <div className="space-y-5">
            <InfoText
              text={t('components.disputeFeature.requestSummary')}
              className="!text-lg !text-light-text-primary !font-bold dark:!text-dark-text-primary"
            />

            <div className="">
              <Table
                columns={columns}
                className="customTable"
                dataSource={orderDataSource}
                pagination={false}
                showHeader={false}
                size="middle"
              />
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>
  );
}
